import {CachedVariable} from '@lexriver/cache'
import { JsonMenuItem } from '../json-data-types/JsonMenuItem'
import { RequestMaker } from './RequestMaker'

const filename = 'ServerMenu'

export module ServerMenu{
    const cachedAllItems = new CachedVariable<JsonMenuItem[]>({
        maxAgeInMilliseconds: 5*60*1000,
        useLazyUpdate: true,
        updateFunction: async () => {
            const allItems = await RequestMaker.sendWebsocketJsonRequestAsync<JsonMenuItem[]>({
                query:'mobile-topmenuitems',
                params:{}
            }, filename)
            if(!allItems){
                throw new Error('unable to query topmenuitems')
            }
            return allItems
        }
    })

    export async function clearCacheAsync(){
        await cachedAllItems.clearCacheAsync()
    }

    export async function getTopLevelItemsSortedAsync(){
        const allItems = await cachedAllItems.getAsync()
        return allItems.filter(x => !x.parentId).sort((a,b) => a.orderIndex-b.orderIndex)
    }

    export async function getSubItemsSortedAsync(parentItemId:number){
        const allItems = await cachedAllItems.getAsync()
        return allItems.filter(x => x.parentId === parentItemId).sort((a,b) => a.orderIndex-b.orderIndex)
    }

    export async function getAllAsync(){
        return await cachedAllItems.getAsync()
    }

}